import { updateFloorSetup } from '@/api/page'

const state = {
  floorSetup: {
    floorDisplayName: "",
    floorId: "",
    floorType:0,//0：推荐分类页面，1：推荐店铺页面
  },
  floorTypeEnum:[
    "推荐分类",
    "推荐店铺"
  ]
}
const mutations = {

  SET_FLOOR_NAME: (state, name) => {
    state.floorSetup.floorDisplayName = name
  },
  SET_FLOOR:(state,floor)=>{
    state.floorSetup = floor
  }
}
const actions = {
  setFloorName({commit}, name) {
    commit('SET_FLOOR_NAME', name)
  },
  setFloor({commit}, floor){
    commit('SET_FLOOR', floor)
  },
  submitFloor({commit}, floor){
    return new Promise((resolve,reject)=>{
      let data = {...floor,id:floor.floorId}
      updateFloorSetup(data).then((d)=>{
          commit('SET_FLOOR',floor)
          resolve("修改成功")
      })
    })
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/page.js